import React from "react";
import Polaroid from "../polaroid/Polaroid";
import { TriviaQuestion } from "./TriviaQuestion";

interface TriviaRoundProps {
  makeGuess: (guess: string) => void;
  question: TriviaQuestion;
  guess: string | undefined;
  year: number;
}

export default function TriviaOptions({
  makeGuess,
  question,
  guess,
  year,
}: TriviaRoundProps) {
  const guessHasBeenMade = guess !== undefined;
  const getBackground = (answerOption: string) => {
    if (guessHasBeenMade) {
      if (question.isCorrect(answerOption)) {
        return "bg-green-200";
      } else if (guess === answerOption) {
        return "bg-red-200";
      }
    }
    return "bg-white";
  };

  switch (year) {
    case 2025:
      return (
        <div className="flex flex-col items-center justify-center gap-2">
          <div className="flex flex-row gap-2">
            <Polaroid
              src="/assets/josh/face.png"
              caption="Josh"
              background={getBackground("Josh")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Josh");
              }}
              size="small"
            />
            <Polaroid
              src="/assets/jace/face.png"
              caption="Jace"
              background={getBackground("Jace")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Jace");
              }}
              size="small"
            />
            <Polaroid
              src="/assets/max/2025/face.png"
              caption="Max"
              background={getBackground("Max")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Max");
              }}
              size="small"
            />
          </div>
          <div className="flex flex-row gap-2">
            <Polaroid
              src="/assets/myron/face.png"
              caption="Myron"
              background={getBackground("Myron")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Myron");
              }}
              size="small"
            />
            <Polaroid
              src="/assets/liam/2025/face.png"
              caption="Liam"
              background={getBackground("Liam")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Liam");
              }}
              size="small"
            />
          </div>
        </div>
      );
    case 2024:
      return (
        <div className="flex flex-col items-center justify-center gap-2">
          <div className="flex flex-row gap-2">
            <Polaroid
              src="/assets/glenn/face.png"
              caption="Glenn"
              background={getBackground("Glenn")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Glenn");
              }}
              size="small"
            />
            <Polaroid
              src="/assets/jace/face.png"
              caption="Jace"
              background={getBackground("Jace")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Jace");
              }}
              size="small"
            />
            <Polaroid
              src="/assets/max/2024/face.png"
              caption="Max"
              background={getBackground("Max")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Max");
              }}
              size="small"
            />
          </div>
          <div className="flex flex-row gap-2">
            <Polaroid
              src="/assets/myron/face.png"
              caption="Myron"
              background={getBackground("Myron")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Myron");
              }}
              size="small"
            />
            <Polaroid
              src="/assets/liam/2024/face.png"
              caption="Liam"
              background={getBackground("Liam")}
              isClickable={!guessHasBeenMade}
              onClick={() => {
                makeGuess("Liam");
              }}
              size="small"
            />
          </div>
        </div>
      );
    default:
      return <div>Invalid year for trivia options</div>;
  }
}
